export default __webpack_public_path__ + "static/media/add_project.de30255e.svg";